function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M32,7c13.81,0,25,11.19,25,25s-11.19,25-25,25c-5.3,0-10.23-1.66-14.3-4.48-1.42-1-1.77-2.94-.77-4.36s2.94-1.76,4.36-.77c3.04,2.12,6.73,3.36,10.71,3.36,10.35,0,18.75-8.4,18.75-18.75s-8.4-18.75-18.75-18.75c-5.18,0-9.86,2.1-13.25,5.49l3.01,3.01c1.47,1.47.43,4-1.66,4h-10.75c-1.3,0-2.34-1.04-2.34-2.34v-10.75c0-2.08,2.53-3.12,4-1.65l3.32,3.32c4.52-4.52,10.77-7.32,17.68-7.32ZM31.99,19.5c1.3,0,2.34,1.04,2.34,2.34v9.19l6.35,6.35c.92.91.91,2.39,0,3.31-.91.92-2.39.92-3.31,0l-7.03-7.03c-.44-.44-.68-1.03-.68-1.66v-10.16c0-1.3,1.05-2.34,2.34-2.34h0Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/viewHistoryIc.31be541d.svg";
export { SvgComponent as ReactComponent };